import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { StudentService } from './../../shared-components/student/student.service';
import { StudentFieldService } from './student-field.service';
import { StudentField, TabMenu, StudentFieldLookup } from './student-field.model';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { YearService } from '../../shared-components/year/year.service';
import { Student } from '../../shared-components/student/student.model';
import { Subscription, Observable, Subject, forkJoin } from 'rxjs';
import { RouterStateSnapshot } from '@angular/router';
import { UserService } from '../../shared-components/user/user.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { CustomizationFrameworkService } from '../../shared-modules/customization-framework/customization-framework.service';
import { take } from 'rxjs/operators';
import { CSTCustomPage } from '../../shared-modules/customization-framework/models/cst-custom-page.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { CustomPageTabGroupComponent } from '../../shared-modules/customization-framework/custom-page-tab-group/custom-page-tab-group.component';
import { enmCSTModuleNames } from '../../shared-modules/customization-framework/models/custom-data-module.model';
import { enmCustomDataObjects } from '../../shared-modules/customization-framework/models/custom-data-object.model';

@AutoUnsubscribe({includeArrays: true})
@Component({
    selector: 'app-student-fields',
    templateUrl: './student-fields.component.html',
    styleUrls: ['./student-fields.componant.css']
})
export class StudentFieldsComponent implements OnInit, AfterViewInit, OnDestroy {
    selectedStudent: Student;
    subscriptions: Subscription[] = [];
    StudentFields: StudentField[] = [];
    StudentField: StudentField = new StudentField();
    selectedStudentSubscription: Subscription;
    student360YearSubscription: Subscription;
    obj: StudentFieldLookup = new StudentFieldLookup();
    idFields: StudentField[];
    distinctTabId = [];
    errors: ErrorList[] = [];
    error: ErrorList = new ErrorList();
    unsavedChanges: boolean;
    studentDateFields = [];
    isStudentIdError = [];
    isStateIdError = [];
    studentHeaderHeight = 0;
    // public tableHeight: number;
    footerHeight = 0;
    ElemAptitudeField: StudentField;
    @ViewChild('studentHeader', { static: true }) studentHeaderRef: ElementRef;
    @ViewChild('footer', { static: true }) footerRef: ElementRef;
    enableSave: boolean;
    showCustomPages: boolean;
    customPages: CSTCustomPage[] = [];
    customPagesRetrieved: boolean;
    @ViewChild('tabGroup') tabGroup: CustomPageTabGroupComponent;

    @ViewChild('divUserDefinedField', { static: true }) divUserDefinedField: ElementRef;
    public observableStudentFieldSaved = new Subject<boolean>();
    observableStudentFieldSavedStream$ = this.observableStudentFieldSaved.asObservable();
    constructor(
        private StudentFieldservice: StudentFieldService,
        private studentService: StudentService,
        private yearService: YearService,
        private userService: UserService,
        private loginService: LoginService,
        private customizationFrameworkService: CustomizationFrameworkService

    ) {
        this.showCustomPages = this.loginService.LoginSettings.EnableCustomizationFramework && this.loginService.LoginSettings.C360CustomFieldsImported;
        this.StudentField.FieldOptions = [];
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                this.loadStudentInfo(studentId);
            });
        this.student360YearSubscription = yearService.observableStudent360YearStream$.subscribe(
            student360Year => {
                this.getStudentFieldsByStudentId();
            }
        );
    }

    ngOnInit() {
        // this.tableHeight = 450;
        this.unsavedChanges = false;
        this.StudentField.TabMenus = [];
        this.errors = [];
        this.getUserPermission();
        if (this.showCustomPages) {
            this.enableSave = true;
            this.getCustomPages();
        }
    }
    // Angular Material
    windowResize() {
        // if (this.divUserDefinedField != undefined) {
        //     this.tableHeight = window.innerHeight - this.studentHeaderHeight - this.footerHeight - 55;
        // }
    }

    getUserPermission() {
        this.StudentField.ValidateIdLengthOnly = false;

        this.userService.getUserPermissions(this.yearService.student360Year.Id, this.yearService.student360Year.SchoolID).subscribe(userPermissions => {
            const ESILDMPermisssion = userPermissions.filter(x => x.PermissionCode == 'SD_ESILDM');
            if (ESILDMPermisssion != null && ESILDMPermisssion.length > 0) {
                this.StudentField.ValidateIdLengthOnly = true;
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        setTimeout(() => {
            this.windowResize();
        }, 1000);

    }

    getTabTitle() {
        const tab: TabMenu[] = this.StudentField.TabMenus.filter(x => x.TabId == this.StudentField.SelectedTabId);
        if (tab.length > 0) {
            return tab[0].TabTitle;
        }
        return '';
    }

    filterStudentField(columnPosition, row) {
        return this.StudentFields.filter(x => x.ColumnPosition == columnPosition && x.TabId == this.StudentField.SelectedTabId && x.Row == row);
    }
    visibleMiddleColumn(row) {
        return (this.StudentFields.filter(x => x.ColumnPosition == 1 && x.TabId == this.StudentField.SelectedTabId && x.Row == row).length == 0) && (this.StudentFields.filter(y => y.ColumnPosition == 2 && y.TabId == this.StudentField.SelectedTabId && y.Row == row).length > 0);
    }
    loadStudentInfo(studentId: number) {
        if (this.showCustomPages && this.customPagesRetrieved) {
            // reload custom pages when student changes
            const customPagesRetrieved = this.customPagesRetrieved;
            this.customPagesRetrieved = false;
            setTimeout(() => {
                this.customPagesRetrieved = customPagesRetrieved;
            }, 1);
        }
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.getStudentFieldsByStudentId();

    }

    // Methods
    getStudentFieldsByStudentId() {
        // POST: obtains the data from the server and organizes the table data
        if (!this.showCustomPages) {
            this.unsavedChanges = false;
            this.StudentFields = [];
            this.subscriptions.push(
                this.StudentFieldservice.getStudentFieldsByStudentId().subscribe(result => {
                    this.StudentFields = result;
                    this.StudentField.TabMenus = [];
                    this.StudentFields.forEach(element => {
                        let numericFieldLength = 0;
                        element.FieldWidth = 60;
                        if (element.DataFieldFormatType == 3 && element.ObjectType != 2 && element.Visible && !element.DataTypeFormat && element.ColumnData != null && element.ColumnData != undefined) {
                            // if numeric field then check length of data
                            numericFieldLength = element.ColumnData.length;
                            if (element.DisplaySize < numericFieldLength) {
                                element.FieldWidth = (parseInt(numericFieldLength.toString(), 10) * 9) + 15;
                            } else {
                                element.FieldWidth = (parseInt(element.DisplaySize.toString(), 10) * 9) + 15;
                            }
                        } else {
                            element.FieldWidth = (parseInt(element.DisplaySize.toString(), 10) * 9) + 15;
                        }

                        if (element.FieldWidth < 60) {
                            element.FieldWidth = 60;
                        }
                    });

                    this.distinctTabId = Array.from(new Set(result.map((data: any) => data.TabId)));
                    this.distinctTabId.forEach(TabId => {
                        const field = result.filter(x => x.TabId === parseInt(TabId, 10));
                        if (field != null) {
                            const maxRow = Math.max.apply(Math, field.map(function (data) { return data.Row; }));
                            this.StudentField.TabMenus.push({ 'TabId': field[0].TabId, 'TabTitle': field[0].TabTitle, 'TabSequence': field[0].TabSequence, 'MaxRow': maxRow });
                        }
                    });
                    this.StudentField.TabMenus = this.StudentField.TabMenus.sort((a, b) => a.TabSequence - b.TabSequence);
                    if (this.StudentField.TabMenus.length > 0 && (this.StudentField.SelectedTabId == undefined || this.StudentField.SelectedTabId == null)) {
                        this.StudentField.SelectedTabId = this.StudentField.TabMenus[0].TabId;
                    }
                    this.studentDateFields = [];
                    this.studentDateFields = this.StudentFields.filter(field => field.ObjectType == 1 && field.DataFieldFormatType == 4 && field.ColumnData != null);

                    this.studentDateFields.forEach(dt => {
                        dt.ColumnData = new Date(dt.ColumnData);
                    });
                    this.StudentFields.forEach(x => {
                        x.OldColumnData = x.ColumnData;
                        x.OldExternalDataId = x.ExternalDataId;
                        if (x.Visible != true && x.ObjectType == 2) {
                            x.OptionSelected = 0;
                        }
                    });
                    const editableFields: StudentField[] = this.StudentFields.filter(x => x.Editable == true);
                    if (editableFields != null && editableFields.length > 0) {
                        this.enableSave = true;
                    } else {
                        this.enableSave = false;
                    }
                    this.getStudentFieldOptions();
                })
            );
        }
    }

    getStudentFieldOptions() {
        const dataFieldIds = this.StudentFields.filter(field => field.ObjectType == 2).map(field => field.DataFieldId);
        const StudentFields = [];
        StudentFields.push(dataFieldIds.join());
        this.StudentFieldservice.getStudentFieldOptions(StudentFields).subscribe(results => {
            this.StudentField.FieldOptions = [];
            for (let i = 0; i < dataFieldIds.length; i++) {
                const fieldOptions = results.filter(data => data.DataFieldId == dataFieldIds[i]);
                const fields = this.StudentFields.filter(st => st.DataFieldId == dataFieldIds[i]);
            }
            dataFieldIds.forEach(dataFieldId => {
                const fieldOptions = Object.assign([], results.filter(field => field.DataFieldId === parseInt(dataFieldId.toString(), 10)));
                const fields = this.StudentFields.filter(st => st.DataFieldId == parseInt(dataFieldId.toString(), 10));
                if (fields != null) {
                    const checkBlankRecord = fieldOptions.filter(x => x.Code.trim() == '' && x.CodeDescription.trim() == '');
                    if (checkBlankRecord.length == 0 && fields[0].FieldName != 'Gender' && fields[0].FieldName != 'Grade') {
                        this.obj.Id = -1;
                        this.obj.Code = '';
                        this.obj.CodeDescription = '';
                        this.obj.Sequence = -1;
                        this.obj.DataFieldId = parseInt(dataFieldId.toString(), 10);
                        fieldOptions.push(this.obj);
                    }
                    for (let i = 0; i < fieldOptions.length; i++) {
                        fieldOptions[i].Id = fieldOptions[i].Id;
                        if (fieldOptions[i].Code.trim() == '' && fieldOptions[i].CodeDescription.trim() == '') {
                            fieldOptions[i].Sequence = -1;
                            const existOption = fieldOptions.filter(x => Number(x.Id) == Number(fields[0].ExternalDataId));
                            if (existOption.length == 0) {
                                fields[0].ExternalDataId = fieldOptions[i].Id;
                            }
                        }
                        this.StudentField.FieldOptions.push(Object.assign(fieldOptions[i]));
                    }
                }
            });
        });
    }

    menuSelected(tabId: number) {
        this.StudentField.SelectedTabId = tabId;
    }

    tabRows() {
        const tabMenu = this.StudentField.TabMenus.find(tabmenu => tabmenu.TabId == this.StudentField.SelectedTabId);
        const rows = [];
        if (tabMenu != null) {
            for (let i = 1; i <= tabMenu.MaxRow; i++) {
                rows.push(i);
            }
        }
        return rows;
    }

    changeFieldData(field: StudentField) {
        if ((field.OldColumnData != field.ColumnData && (!(field.OldColumnData == null && field.ColumnData == '') && !(field.OldColumnData == '' && field.ColumnData == null))) || field.OldExternalDataId != field.ExternalDataId) {
            field.isEdited = true;
            this.unsavedChanges = true;
        }
        else {
            field.isEdited = false;
        }
    }

    compareObjects(o1: number, o2: number): boolean {
        if (o2 == null) {
            o2 = -1;
        }
        return (o1 == o2);
    }

    saveClick = function (isSaveData: boolean) {
        this.StudentField.ErrorCollection = [];
        this.errors = [];
        if (!this.showCustomPages) {
            const objStudentFields: StudentField[] = Object.assign(this.StudentFields.filter(x => x.isEdited == true));
            if (objStudentFields.length > 0) {
                if (isSaveData == true) {
                    this.validateData(objStudentFields, true);
                } else {
                    this.validateData(objStudentFields, false);
                }
            }
        }
        else {
            this.errors = this.tabGroup.validateAllPages();
            if (this.errors.length == 0) {
                this.tabGroup.saveAllCustomPages();
            }
        }
    };

    // eslint-disable-next-line complexity
    validateDate(div: string, IsValidate: boolean, field: StudentField) {
        let isInvalidDate: boolean;
        isInvalidDate = false;
        const columnData = (<HTMLInputElement>document.getElementById(div + field.DataFieldId)).value;
        if ((columnData !== undefined && columnData !== '' && columnData != null)) {
            let month = null;
            let day = null;
            let year = null;
            if (columnData.indexOf('/') > -1) {
                const res = columnData.split('/');
                if (res.length > 1) {
                    month = res[0];
                    day = res[1];
                    year = res[2];
                }
            }
            else {
                if (columnData.length == 8) {
                    month = columnData.substring(0, 2);
                    day = columnData.substring(2, 4);
                    year = columnData.substring(4, 8);
                }
            }
            if (isNaN(month) || isNaN(day) || isNaN(year)) {
                isInvalidDate = true;
            }
            month = Number(month);
            day = Number(day);
            year = Number(year);
            if (month < 1 || month > 12) { // check month range
                isInvalidDate = true;
            }
            if (day < 1 || day > 31) {
                isInvalidDate = true;
            }
            if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
                isInvalidDate = true;
            }
            if (month == 2) {
                const isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
                if (day > 29 || (day === 29 && !isleap)) {
                    isInvalidDate = true;
                }
            }
        }
        if (isInvalidDate) {
            document.getElementById('span' + div + field.DataFieldId).style.display = 'inline-block';
            document.getElementById(div + field.DataFieldId).nodeValue = '';

            this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
            this.error.fieldName = field.FieldName;
            this.error.errorMsg = ' Invalid Date';
            this.error.fieldRef = null;
            this.StudentField.ErrorCollection.push(this.error);
        } else {
            this.StudentField.ErrorCollection = [];
            document.getElementById('span' + div + field.DataFieldId).style.display = 'none';
            this.changeFieldData(field);
        }
    }

    callbackFunction(objStudentFields: StudentField[]) {
        this.StudentFieldservice.saveStudentFieldsData(this.yearService.student360Year.Id, this.selectedStudent.Id, objStudentFields).subscribe(results => {
            if (results == null) {
                this.getStudentFieldsByStudentId();
                this.unsavedChanges = false;
            }
            else {
                objStudentFields.forEach((StudentFields, e: number) => {
                    if (objStudentFields[e].DataFieldId == results.DataFieldId) {
                        return;
                    }
                    const editedField: StudentField[] = this.StudentFields.filter(x => x.DataFieldId == objStudentFields[e].DataFieldId);
                    if (editedField != null && editedField.length > 0) {
                        editedField[0].isEdited = false;
                        editedField[0].OldColumnData = editedField[0].ColumnData;
                        editedField[0].OldExternalDataId = editedField[0].ExternalDataId;
                    }
                });
                this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                this.error.fieldName = results.FieldName;
                this.error.errorMsg = results.Error;
                this.StudentField.ErrorCollection.push(this.error);
            }
        });
    }

    validateData(objStudentFields: StudentField[], callbackFunction: boolean) {
        objStudentFields.forEach((objStudentField, i: number) => {
            if (objStudentFields[i].DataFieldFormatType == 4 && objStudentFields[i].ObjectType != 2) {
                if (objStudentFields[i].ColumnData != undefined && objStudentFields[i].ColumnData != null && objStudentFields[i].ColumnData != '') {
                    objStudentFields[i].ColumnData = new Date(objStudentFields[i].ColumnData).toLocaleDateString();
                }
                else {
                    objStudentFields[i].ColumnData = '';
                }
            }
        });

        if (objStudentFields.length > 0) {
            objStudentFields.forEach((objStudentField, index: number) => {
                objStudentFields[index].FieldOptions = [];
                const fieldsLookup: StudentFieldLookup[] = this.StudentField.FieldOptions.filter(function (o) { return (o.Id == objStudentFields[index].ExternalDataId && o.DataFieldId == objStudentFields[index].DataFieldId); });
                if (fieldsLookup != null || fieldsLookup != undefined) {
                    objStudentFields[index].FieldOptions = fieldsLookup;
                }
            });
            this.StudentField.ErrorCollection = [];
            this.StudentField.ErrorCount = 0;
            const fields: StudentField[] = Object.assign(objStudentFields.filter(function (element) {
                return (element.DataFieldFormatType == 200 || element.DataFieldFormatType == 201 || element.DataFieldFormatType == 202 || (element.DataFieldFormatType == 204 && element.FieldOptions.length > 0 && element.FieldOptions[0].CodeDescription.trim() != ''));
            }));
            if (fields.length > 0) {
                this.StudentFieldservice.validateStudentFieldsData(this.yearService.student360Year.Id, this.selectedStudent.Id, fields).subscribe(results => {
                    results.forEach((res, i: number) => {
                        this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                        this.error.fieldName = res.FieldName;
                        if (res.Error != '') {
                            this.error.errorMsg = res.Error;
                        }
                        else {
                            this.error.errorMsg = ' has the value ' + res.ColumnData + ' which is not valid Email';
                        }
                        this.StudentField.ErrorCollection.push(this.error);
                    });
                    if (this.validateOtherFields(objStudentFields)) {
                        if (this.StudentField.ErrorCount == 0 && callbackFunction == true) {
                            this.callbackFunction(objStudentFields);
                        }
                    } else {
                        this.showErors();
                    }
                });
            } else {
                if (this.validateOtherFields(objStudentFields)) {
                    if (this.StudentField.ErrorCount == 0 && callbackFunction == true) {
                        this.callbackFunction(objStudentFields);
                    }
                }
                else {
                    this.showErors();
                }
            }
        }
    }

    validateOtherFields(objStudentFields: StudentField[]) {
        const emailFields: StudentField[] = Object.assign(objStudentFields.filter(function (element) { return (element.DataFieldFormatType == 205); }));
        emailFields.forEach((email, i: number) => {
            if (emailFields[i].ColumnData != undefined && emailFields[i].ColumnData != null && emailFields[i].ColumnData != '') {
                const regex = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
                if (!regex.test(String(emailFields[i].ColumnData).toLowerCase())) {
                    this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                    this.error.fieldName = emailFields[i].FieldName;
                    this.error.errorMsg = ' has the value ' + emailFields[i].ColumnData + ' which is not valid Email';
                    this.error.fieldRef = null;
                    this.StudentField.ErrorCollection.push(this.error);
                }
            }
        });

        if (objStudentFields.filter(x => x.FieldName == 'ElemAptitude').length > 0) {
            this.ElemAptitudeField = Object.assign(objStudentFields.filter(x => x.FieldName == 'ElemAptitude')[0]);
        }

        if (this.ElemAptitudeField != null && this.ElemAptitudeField.ColumnData != undefined && this.ElemAptitudeField.ColumnData != null && this.ElemAptitudeField.ColumnData != '' && (Number(this.ElemAptitudeField.ColumnData) > 255 || Number(this.ElemAptitudeField.ColumnData) < 0)) {
            this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
            this.error.fieldName = this.ElemAptitudeField.FieldName;
            this.error.errorMsg = ' value must be between 0 to 255!';
            this.error.fieldRef = null;
            this.StudentField.ErrorCollection.push(this.error);
        }

        this.isStudentIdError = this.StudentFields.filter(element => element.DataFieldFormatType == 201);
        this.isStateIdError = this.StudentFields.filter(element => element.DataFieldFormatType == 202);
        this.idFields = Object.assign(objStudentFields.filter((element) => {
            return ((element.DataFieldFormatType == 201 && this.isStudentIdError.length == 1) || (element.DataFieldFormatType == 202 && this.isStateIdError.length == 1) || element.DataFieldFormatType == 203);
        }));

        this.idFields.forEach((idF, i: number) => {
            if (idF.ColumnData != undefined && idF.ColumnData != null && idF.ColumnData != '') {
                const intMaxValue = (new Array(idF.FieldSize)).fill(9).join('');
                if ((idF.DataFieldFormatType == 201 && ((this.StudentField.ValidateIdLengthOnly
                    && (idF.ColumnData.length != idF.FieldSize))
                    || (!this.StudentField.ValidateIdLengthOnly && ((Number(idF.ColumnData) < Number(idF.MinimumFieldValue)) || (Number(idF.ColumnData) > Number(intMaxValue))))))
                    || (idF.DataFieldFormatType == 202 && (idF.ColumnData.length != idF.FieldSize))
                    || (idF.DataFieldFormatType == 203 && (idF.ColumnData.length != 9))) {

                    this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                    this.error.fieldName = idF.FieldName;
                    this.error.errorMsg = ' has the value ' + idF.ColumnData + '  which is not formatted correctly or an incorrect length.  Proper format is ' + idF.DataTypeFormat;
                    this.error.fieldRef = null;
                    this.StudentField.ErrorCollection.push(this.error);
                }
            }
        });

        const lunchPin: StudentField[] = Object.assign(objStudentFields.filter(function (element) { return element.DataFieldFormatType == 200; }));
        lunchPin.forEach((lun, i: number) => {
            if (lunchPin[i].ColumnData != undefined && lunchPin[i].ColumnData != null && lunchPin[i].ColumnData != '') {
                if (lunchPin[i].ColumnData.length != lunchPin[i].FieldSize) {

                    this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                    this.error.fieldName = lunchPin[i].FieldName;
                    this.error.errorMsg = ' has the value ' + lunchPin[i].ColumnData + '  which is not formatted correctly or an incorrect length.  Proper format is ' + lunchPin[i].DataTypeFormat;
                    this.StudentField.ErrorCollection.push(this.error);
                }

                if (isNaN(Number(lunchPin[i].ColumnData))) {
                    this.StudentField.ErrorCount = this.StudentField.ErrorCount + 1;
                    this.error.fieldName = lunchPin[i].FieldName;
                    this.error.errorMsg = ' should be numeric!';
                    this.StudentField.ErrorCollection.push(this.error);
                }
            }
        });
        if (this.StudentField.ErrorCount == 0) {
            return true;
        } else {
            return false;
        }
    }

    showErors() {
        this.errors = [];
        if (this.StudentField.ErrorCollection.length > 0) {
            this.StudentField.ErrorCollection.forEach((errField, index: number) => {
                const element = new ElementRef(document.getElementById('FieldData' + errField.fieldName));
                const objError: ErrorList = {
                    fieldName: errField.fieldName,
                    errorMsg: errField.errorMsg,
                    fieldRef: element
                };
                if (this.errors.filter(x => x.fieldName == objError.fieldName).length < 1) {
                    this.errors.push(objError);
                }
            });
        }
    }

    checkErrors(nextState?: RouterStateSnapshot): number {
        this.errors = [];
        this.saveClick(false);
        if (this.unsavedChanges) {
            return 0;
        }
        return 1;
    }

    save(): Observable<boolean> {
        this.saveClick(true);
        return this.observableStudentFieldSavedStream$;
    }

    ngAfterViewInit() {
        if (this.studentHeaderRef != undefined) {
            this.studentHeaderHeight = this.studentHeaderRef.nativeElement.offsetHeight;
        }
        if (this.footerRef != undefined) {
            this.footerHeight = this.footerRef.nativeElement.offsetHeight;
        }
        this.onResize();
    }

    ngOnDestroy() {

    }

    getCustomPages() {
        const serverCalls = [
            this.customizationFrameworkService.getCustomPagesByModuleObject(enmCSTModuleNames.HouseholdRegistration, enmCustomDataObjects.Student, this.yearService.defaultYear.SiteYearId),
            this.customizationFrameworkService.getCustomPagesByModuleObject(enmCSTModuleNames.HouseholdRegistration, enmCustomDataObjects.StudentByYear, this.yearService.defaultYear.SiteYearId),
            this.customizationFrameworkService.getCustomPagesByModuleObject(enmCSTModuleNames.HouseholdRegistration, enmCustomDataObjects.StateReportingByYear, this.yearService.defaultYear.SiteYearId)
        ];

        this.subscriptions.push(
            forkJoin(serverCalls).pipe(take(1)).subscribe(result => {
                const allPages = result[0].concat(result[1]).concat(result[2]);
                this.customPages = allPages;
                this.customPagesRetrieved = true;
            }));
    }
}
